import { FC } from "react";

// Purpose-built 4-cell skeleton (not MetricWidgetBase's single undifferentiated bone) so the section
// preserves its 4-column shape while loading, per the accepted spike recommendation (#201378).
export const GapByCountyStatusSkeleton: FC = () => (
  <div className="network-portfolio-management-project-card__gap-status-row skeleton shimmer" data-testid="network-portfolio-management-card-gap-status-skeleton">
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="network-portfolio-management-project-card__gap-status-cell">
        <div className="bone network-portfolio-management-project-card-skeleton__gap-label-bone" />
        <div className="bone network-portfolio-management-project-card-skeleton__gap-num-bone" />
      </div>
    ))}
  </div>
);
